import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../../settings/config.json';
import { Button, Form, Input, Space, Alert } from 'antd';

const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};
const tailLayoutM = {
  wrapperCol: {
    offset: 6,
    span: 16,
  },
};

function AddPoem() {
  const [form] = Form.useForm();
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`/api/settings`);
        const data = response.data[0];
  
        if (data && data.client) {
          console.log('Received data:', data);
          form.setFieldsValue(data);
        } else {
          console.error('Неверная структура данных:', data);
        }
      } catch (error) {
        console.error('Ошибка при загрузке настроек:', error);
      }
    };
  
    fetchSettings();
  }, [form]);

  const onReset = () => {
    form.resetFields();
  };

  const handleClose = () => {
    setShowAlert(false);
  };

  const handleSubmit = async (values) => {
    try {
      await axios.post(`/api/settings/edit`, values);

      setShowAlert(true);
    } catch (error) {
      console.error('Ошибка при обновлении настроек:', error);
    }
  };

  return (
    <div className='form-container'>
      <>
        <Form
          {...layout}
          form={form}
          name="control-hooks"
          onFinish={handleSubmit}
          style={{ maxWidth: 600 }}
          className="centered-form"
        >
          {showAlert && (
            <center>
              <Alert message="Əlavə edildi" type="success" showIcon closable afterClose={handleClose} style={{ maxWidth: 370 }} />
            </center>
          )}

          <center><h5 className='text-light'>Client</h5></center>

          <Form.Item name={['client', 'phone']} label="Nömrə" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'email']} label="Email" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'loading']} label="Loading" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <center><h5 className='text-light'>Links</h5></center>

          <Form.Item name={['links', 'youtube']} label="Youtube" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['links', 'instagram']} label="Instagram" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['links', 'whatsapp']} label="Whatsapp" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <center><h5 className='text-light'>Haqqımızda</h5></center>

          <Form.Item name={['client', 'homePage', 'aboutUs', 'title']} label="Başlıq" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'homePage', 'aboutUs', 'content']} label="Text" rules={[{ required: true, message: '' }]}>
            <Input.TextArea rows={6} size="large" />
          </Form.Item>

          <center><h5 className='text-light'>Buttons</h5></center>

          <Form.Item name={['client', 'homePage', 'sendMsg', 'buttons', 'send']} label="Göndər" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'homePage', 'sendMsg', 'buttons', 'clear']} label="Sil" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <center><h5 className='text-light'>Placeholders</h5></center>

          <Form.Item name={['client', 'homePage', 'sendMsg', 'placeholders', 'name']} label="Ad" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'homePage', 'sendMsg', 'placeholders', 'email']} label="Email" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'homePage', 'sendMsg', 'placeholders', 'phone']} label="Nömrə" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'homePage', 'sendMsg', 'placeholders', 'message']} label="Mesaj" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <center><h5 className='text-light'>Footer</h5></center>

          <Form.Item name={['client', 'footer', 'title']} label="Başlıq" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'footer', 'content']} label="Təsviri" rules={[{ required: true, message: '' }]}>
            <Input.TextArea rows={6} size="large" />
          </Form.Item>

          <center><h5 className='text-light'>Navbar</h5></center>

          <Form.Item name={['client', 'navbar', 'aboutUs']} label="Haqqımızda" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'navbar', 'poets']} label="Şairlər" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'navbar', 'contactUs']} label="Əlaqə" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'navbar', 'video']} label="Səs" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'navbar', 'poetry']} label="Poeziya" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <center><h5 className='text-light'>Video Page</h5></center>

          <Form.Item name={['client', 'videoPage', 'title']} label="Başlıq" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'videoPage', 'description']} label="Təsviri" rules={[{ required: true, message: '' }]}>
            <Input.TextArea rows={6} size="large" />
          </Form.Item>

          <Form.Item name={['client', 'videoPage', 'videos', 'video1']} label="Video 1" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'videoPage', 'videos', 'video2']} label="Video 2" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'videoPage', 'videos', 'video3']} label="Video 3" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <center><h5 className='text-light'>Göndərilən Şeirlər</h5></center>

          <Form.Item name={['client', 'poetryPage', 'title']} label="Başlıq" rules={[{ required: true, message: '' }]}>
            <Input size="large" />
          </Form.Item>

          <Form.Item name={['client', 'poetryPage', 'description']} label="Təsviri" rules={[{ required: true, message: '' }]}>
            <Input.TextArea rows={6} size="large" />
          </Form.Item>


            <Form.Item {...tailLayoutM}>
              <Space>
                <Button type="primary" size="large" danger htmlType="submit">
                  Göndər
                </Button>
                <Button type="dashed" secondary size="large" htmlType="button" onClick={onReset}>
                  Sil
                </Button>
              </Space>
            </Form.Item>
          </Form>
      </>
    </div>
  );
}

export default AddPoem;